var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Title from '../../../atoms/Title';
import Desc from '../../../atoms/Desc';
import { VerticalGap } from '../../../atoms/Gap/Gap';
import CtaBtn from '../../../atoms/CtaBtn';
import { neutralDay, scc } from '@teamsparta/design-system';
import { BottomContents, MainContents } from '../../../../styles/_common.style';
import { useIsMobile } from '../../../../businessLogics/hooks';
import { emailAtom } from '../../../../stores';
import { useAtom } from 'jotai';
import { useChangeEmail } from '../../../../businessLogics/apis';
var ChangeEmailReady = function () {
    var email = useAtom(emailAtom)[0];
    var isMobile = useIsMobile();
    var changeEmail = useChangeEmail();
    var onClickCta = function () {
        changeEmail.mutate({ newEmail: email });
    };
    return (_jsxs(_Fragment, { children: [_jsxs(MainContents, __assign({ paddingTop: 174, isCenterInMobile: true }, { children: [_jsxs(Title, { children: ["\uC778\uC99D\uD55C \uC774\uBA54\uC77C\uB85C", _jsx("br", {}), "\uACC4\uC815 \uC815\uBCF4\uB97C \uC800\uC7A5\uD560\uAE4C\uC694?"] }), _jsx(VerticalGap, { size: isMobile ? 8 : 12 }), _jsx(Desc, { children: email }), !isMobile && (_jsxs(_Fragment, { children: [_jsx(VerticalGap, { size: 40 }), _jsx(CtaBtn, __assign({ bgColor: scc.red100, color: neutralDay.white, onClickAction: onClickCta }, { children: "\uC800\uC7A5\uD558\uAE30" }))] }))] })), isMobile && (_jsx(BottomContents, { children: _jsx(CtaBtn, __assign({ bgColor: scc.red100, color: neutralDay.white, onClickAction: onClickCta }, { children: "\uC800\uC7A5\uD558\uAE30" })) }))] }));
};
export default ChangeEmailReady;
//# sourceMappingURL=ChangeEmailReady.js.map